import React from 'react';
import './CTA.css';

const CTA = () => {
  const handleBookCall = () => {
    window.open('https://calendly.com/maitreyeegoswami/discoverycall', '_blank');
  };

  return (
    <section className="cta-section" id="calendly">
      <p className="section-label cta-label">Work with us</p>
      <h2 className="cta-heading">
        Your story, presence,<br />and positioning should<br />match your <em>ambition.</em>
      </h2>
      <p className="cta-sub">
        A 30-minute discovery call. No pitch, no pressure. Just a focused conversation to see if there’s a fit.
      </p>
      <button onClick={handleBookCall} className="btn-primary-white">Book a discovery call</button>
      <p className="cta-fine">Maitreyee personally reviews every submission and responds within 24 hours.</p>
    </section>
  );
};

export default CTA;
